import axios from '@axios'
export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        fetchData(ctx, id) {
         
            return new Promise((resolve, reject) => {
              axios
                .get('/blogs/v1/section/getall/'+id)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },
        UpdateOrder(ctx, queryParams) {
            var data = JSON.stringify(queryParams.items);    
            return new Promise((resolve, reject) => {
              axios
                .put('/blogs/v1/section/updateOrdering', data)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },
        addSection(ctx, queryParams) {
           // var data = JSON.stringify(queryParams);  
            return new Promise((resolve, reject) => {
              axios
                .post('/blogs/v1/section/add',queryParams)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },
        UpdateSection(ctx, queryParams) {
            
            return new Promise((resolve, reject) => {
              axios
                .put('/blogs/v1/section/update/'+queryParams.id,queryParams.formData)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },
        deleteSection(ctx, id){
            return new Promise((resolve, reject) => {
                axios
                  .delete('/blogs/v1/section/delete/'+id)
                  .then(response => resolve(response))
                  .catch(error => reject(error))
              })

        }
    }
}